// ════════════ Competitors.js ════════════
import React, { useEffect, useState } from 'react';
import { monitorComp, getCompReports } from '../utils/api';
import { PageTitle, Card, Btn, Input, Loading, Empty, Badge } from '../components/UI';

const urgColor = { HIGH: '#ff6584', MEDIUM: '#ffd200', LOW: '#55efc4' };
const urgBg    = { HIGH: 'rgba(255,101,132,0.1)', MEDIUM: 'rgba(255,210,0,0.1)', LOW: 'rgba(85,239,196,0.1)' };

export default function Competitors() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [running, setRunning] = useState(false);
  const [form, setForm] = useState({ name: '', pageId: '', keyword: '', clientContext: '' });
  const [expanded, setExpanded] = useState(null);

  const load = () => getCompReports().then(r => setReports(r.data?.data?.reports || [])).catch(console.error).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const handleMonitor = async () => {
    if (!form.name || (!form.pageId && !form.keyword)) return alert('Name + (pageId or keyword) required');
    setRunning(true);
    await monitorComp({ ...form, notify: false }).catch(e => alert(e.response?.data?.message || e.message));
    await load();
    setRunning(false);
    setForm({ name: '', pageId: '', keyword: '', clientContext: '' });
  };

  return (
    <div>
      <PageTitle title="🔍 Competitor Monitor" sub="Competitor এর Facebook ads analyze করো" />

      <Card>
        <div style={{ fontWeight: 700, marginBottom: 16 }}>নতুন Competitor Monitor করো</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
          <Input label="Competitor Name *" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
          <Input label="Facebook Page ID" value={form.pageId} onChange={e => setForm({ ...form, pageId: e.target.value })} placeholder="numeric page id" />
          <Input label="Search Keyword" value={form.keyword} onChange={e => setForm({ ...form, keyword: e.target.value })} placeholder="অথবা keyword দিয়ে search" />
          <Input label="Client Context (optional)" value={form.clientContext} onChange={e => setForm({ ...form, clientContext: e.target.value })} placeholder="তোমার business context" />
        </div>
        <Btn onClick={handleMonitor} disabled={running}>{running ? '⏳ Analyzing...' : '🔍 Monitor Competitor'}</Btn>
      </Card>

      {loading ? <Loading /> : reports.length === 0 ? <Empty msg="কোনো competitor report নেই" /> : reports.map((r, i) => (
        <Card key={i}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 16 }}>{r.competitorName}</div>
              <div style={{ fontSize: 12, color: '#6b6b80', marginTop: 3 }}>{new Date(r.createdAt).toLocaleString('bn-BD')} · {r.totalAdsFound} ads found</div>
            </div>
            <span style={{ padding: '4px 12px', borderRadius: 100, fontSize: 12, fontWeight: 700, color: urgColor[r.analysis?.urgencyLevel], background: urgBg[r.analysis?.urgencyLevel] }}>
              {r.analysis?.urgencyLevel}
            </span>
            <Btn color="#1e1e2e" onClick={() => setExpanded(expanded === i ? null : i)} style={{ fontSize: 12 }}>
              {expanded === i ? '▲ Collapse' : '▼ Details'}
            </Btn>
          </div>

          <div style={{ fontSize: 14, color: '#a29bfe', lineHeight: 1.6 }}>{r.analysis?.summary}</div>

          {expanded === i && (
            <div style={{ marginTop: 16, display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
              <div>
                <div style={{ fontWeight: 700, color: '#ffd200', marginBottom: 8, fontSize: 13 }}>📌 Top Angles</div>
                {r.analysis?.topAngles?.map((a, j) => <div key={j} style={{ fontSize: 13, marginBottom: 5 }}>• {a}</div>)}
              </div>
              <div>
                <div style={{ fontWeight: 700, color: '#55efc4', marginBottom: 8, fontSize: 13 }}>🎯 তোমার সুযোগ</div>
                {r.analysis?.opportunities?.map((a, j) => <div key={j} style={{ fontSize: 13, marginBottom: 5, color: '#55efc4' }}>• {a}</div>)}
              </div>
              <div>
                <div style={{ fontWeight: 700, color: '#a29bfe', marginBottom: 8, fontSize: 13 }}>✅ করণীয়</div>
                {r.analysis?.recommendations?.map((a, j) => <div key={j} style={{ fontSize: 13, marginBottom: 5 }}>• {a}</div>)}
              </div>
            </div>
          )}
        </Card>
      ))}
    </div>
  );
}
